var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1715_517",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 34
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1715_517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2187 29.75C9.99931 29.75 8.11632 28.9767 6.56979 27.4302C5.02326 25.8837 4.25 24.0007 4.25 21.7812C4.25 20.7187 4.45069 19.7035 4.85208 18.7354C5.25347 17.7674 5.83194 16.9056 6.5875 16.15L16.15 6.5875C16.9056 5.83194 17.7674 5.25347 18.7354 4.85208C19.7035 4.45069 20.7187 4.25 21.7812 4.25C24.0007 4.25 25.8837 5.02326 27.4302 6.56979C28.9767 8.11632 29.75 9.99931 29.75 12.2187C29.75 13.2812 29.5493 14.2965 29.1479 15.2646C28.7465 16.2326 28.1681 17.0944 27.4125 17.85L17.85 27.4125C17.0944 28.1681 16.2326 28.7465 15.2646 29.1479C14.2965 29.5493 13.2812 29.75 12.2187 29.75ZM21.6396 19.6208L25.4292 15.8667C25.9014 15.3944 26.2674 14.8396 26.5271 14.2021C26.7868 13.5646 26.9167 12.9035 26.9167 12.2187C26.9167 10.8021 26.4149 9.59201 25.4115 8.58854C24.408 7.58507 23.1979 7.08333 21.7812 7.08333C21.0965 7.08333 20.4354 7.21319 19.7979 7.47292C19.1604 7.73264 18.6056 8.09861 18.1333 8.57083L14.3792 12.3604L21.6396 19.6208ZM12.2187 26.9167C12.9035 26.9167 13.5646 26.7868 14.2021 26.5271C14.8396 26.2674 15.3944 25.9014 15.8667 25.4292L19.6208 21.6396L12.3604 14.3792L8.57083 18.1333C8.09861 18.6056 7.73264 19.1604 7.47292 19.7979C7.21319 20.4354 7.08333 21.0965 7.08333 21.7812C7.08333 23.1979 7.58507 24.408 8.58854 25.4115C9.59201 26.4149 10.8021 26.9167 12.2187 26.9167Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPill);
export default __webpack_public_path__ + "static/media/pill.e7fbffde87d94e9ae629cc384055177d.svg";
export { ForwardRef as ReactComponent };